import React, { createContext, ReactNode } from 'react';

interface IPermission {
  'acesso-envio-de-notas': boolean;
  'admin-compliance': boolean;
  'admin-scorecard': boolean;
  'alterar-perfil': boolean;
  'condicoes-de-pagamento': boolean;
  'fale-conosco': boolean;
  'filtro-fornecedor': boolean;
  'funcionalidades-desenvolvedor': boolean;
  'gerenciar-pedidos': boolean;
  'gerenciar-pedidos.confirmados': boolean;
  'gerenciar-pedidos.entregas-concluidas': boolean;
  'gerenciar-pedidos.retiradas-pendentes': boolean;
  'gerenciar-pedidos.pendentes': boolean;
  'gerenciar-pedidos.protocolo-agendamento': boolean;
  'gerenciar-pedidos.recusa-confirmacao': boolean;
  'gerenciar-pedidos.recusados': boolean;
  'gerenciar-pedidos.todos-pedidos': boolean;
  'gerenciar-pedidos.todos-pedidos.features-adicionais': boolean;
  'grupos-opcoes-de-recebimento': boolean;
  'historico-de-agendamento': boolean;
  'lista-de-notas': boolean;
  'lista-de-pagamentos': boolean;
  'lista-de-pedidos-agendados': boolean;
  'lista-de-pedidos-pendentes': boolean;
  'lista-de-usuarios': boolean;
  logs: boolean;
  'manter-comunicados': boolean;
  'manter-contatos': boolean;
  'manter-grupos': boolean;
  'manter-permissoes': boolean;
  'manter-protocolo-logistico': boolean;
  'nova-tela-pedidos-pendentes': boolean;
  'opcoes-de-recebimento': boolean;
  'protocolo-de-agendamento': boolean;
  'protocolo-logistico': boolean;
  qualidade: boolean;
  'user-compliance': boolean;
  'user-scorecard': boolean;
  'ver-lista-de-comunicados': boolean;
  'ver-lista-de-contatos': boolean;
}

interface IAuthContext {
  user: {
    permissions: IPermission;
    role: string;
    isVisaoTok: boolean;
    children?: ReactNode;
  };
}

const authContextData: IAuthContext = {
  user: {
    permissions: {
      'acesso-envio-de-notas': false,
      'admin-compliance': false,
      'admin-scorecard': false,
      'alterar-perfil': false,
      'condicoes-de-pagamento': false,
      'fale-conosco': false,
      'filtro-fornecedor': false,
      'funcionalidades-desenvolvedor': false,
      'gerenciar-pedidos': false,
      'gerenciar-pedidos.confirmados': false,
      'gerenciar-pedidos.entregas-concluidas': false,
      'gerenciar-pedidos.retiradas-pendentes': false,
      'gerenciar-pedidos.pendentes': false,
      'gerenciar-pedidos.protocolo-agendamento': false,
      'gerenciar-pedidos.recusa-confirmacao': false,
      'gerenciar-pedidos.recusados': false,
      'gerenciar-pedidos.todos-pedidos': false,
      'gerenciar-pedidos.todos-pedidos.features-adicionais': false,
      'grupos-opcoes-de-recebimento': false,
      'historico-de-agendamento': false,
      'lista-de-notas': false,
      'lista-de-pagamentos': false,
      'lista-de-pedidos-agendados': false,
      'lista-de-pedidos-pendentes': false,
      'lista-de-usuarios': false,
      logs: false,
      'manter-comunicados': false,
      'manter-contatos': false,
      'manter-grupos': false,
      'manter-permissoes': false,
      'manter-protocolo-logistico': false,
      'nova-tela-pedidos-pendentes': false,
      'opcoes-de-recebimento': false,
      'protocolo-de-agendamento': false,
      'protocolo-logistico': false,
      qualidade: false,
      'user-compliance': false,
      'user-scorecard': false,
      'ver-lista-de-comunicados': false,
      'ver-lista-de-contatos': false
    },
    role: '',
    isVisaoTok: false
  }
};

export const AuthContext = createContext<IAuthContext>(authContextData);

export const AuthProvider = ({ children, permissions, role = '' }: IAuthContext['user']) => {
  return (
    <AuthContext.Provider
      value={{
        user: {
          permissions,
          role,
          isVisaoTok: !!permissions['filtro-fornecedor']
        }
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
